// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wkXS","label":"styles_label__2MeR8"};